// style imports
import Styles from './ChallengeKnowledgeCheck.module.scss';
// react imports
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
// MateriaUI imports
import {
    Tab, Tabs, Paper, ListItemAvatar, Avatar, Tooltip, ListItem, ListItemText, Fab
} from '@mui/material';
// Material Icons import.
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ScienceTwoToneIcon from '@mui/icons-material/ScienceTwoTone';
import SportsScoreIcon from '@mui/icons-material/SportsScore';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
// Components Import
import { ChallengeKnowledgeCheckTabs } from 'components/global/ChallengeKnowledgeCheckTabs/ChallengeKnowledgeCheckTabs';
import { ChallengeExplanation } from 'components/global/ChallengeLayout/ChallengeExplanation';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import InfoDrawer from 'components/global/NodeLayout/InfoDrawer';
import { LightTooltip } from 'components/global/NodeLayout/NodeTopostman';
import { useAPI } from 'components/lib';
// other modules
import _ from 'lodash';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import tcdata from './TestCaseTechniques.json'

// Image assign.
const GoldIcon = `${process.env.REACT_APP_GLOBAL_MEDIA_URL}/topos-icons/global/gold_badge.png`;
const SilverIcon = `${process.env.REACT_APP_GLOBAL_MEDIA_URL}/topos-icons/global/silver_badge.png`;
const BronzeIcon = `${process.env.REACT_APP_GLOBAL_MEDIA_URL}/topos-icons/global/bronze_badge.png`;

export function ChallengeKnowledgeCheck(props) {
    const { challenge_id } = useParams();
    const { context } = useParams();

    const [challengeData, setChallengeData] = useState([]);
    const [tabIndex, setTabIndex] = useState(0);
    const [showExplanation, setShowExplanation] = useState(false);
    // useState to track selected techniques for testcases
    const [selectedAnswers, setSelectedAnswers] = useState([]);
    // useState to store values of all the test cases uncovered
    const [tcReponses, setTCResponses] = useState([]);
    const [progressShake, setProgressShake] = useState(false);
    const [listUUIDS, setListUUIDS] = useState([]);
    const [drawerOpen, setDrawerOpen] = useState(false)

    const [isResults, setIsResults] = useState(context === 'results');
    const [apiURL, setAPIURL] = useState('');
    const [medal, setMedal] = useState('');


    const navigate = useNavigate();

    useEffect(() => {
        if (context === 'results') {
            setIsResults(true);
            setAPIURL(`/api/challenges/${challenge_id}/knowledge/results`);
        }
        if (context === 'attempt') {
            setAPIURL(`/api/challenges/${challenge_id}/knowledge`);
        }
        if (context !== 'attempt' && context !== 'results') {
            navigate('/404');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isResults])

    const { data, loading } = useAPI(apiURL, 'GET');

    const showChallengeInfo = () => {
        setShowExplanation(true);
    };

    const hideChallengeInfo = () => {
        setShowExplanation(false);
    };

    const createAnsArray = (APIData) => {
        const initialUncovered = [];
        APIData[0].testCases.forEach(testCase => {
            initialUncovered[parseInt(testCase)] = -1;
        });
        setSelectedAnswers(initialUncovered);
    };

    // warn when user reloads & close the tab
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            event.preventDefault();
            const message = props.t('Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheck.warn.reload');
            event.returnValue = message;
            return message;
        };

        const handlePageLeave = () => {
            return (props.t('Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheck.warn.close'));
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        window.addEventListener('unload', handlePageLeave);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            window.removeEventListener('unload', handlePageLeave);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    const handleTabChange = (event, newTabIndex) => {
        setTabIndex(newTabIndex);
    };

    const handleSubmit = () => {
        if (!isResults) {
            const options = {
                method: "POST",
                url: `/api/challenges/${challenge_id}/knowledge/submit`,
                headers: {
                    "accept": "application/json",
                },
                data: { selectedAnswers: selectedAnswers },
            };
            axios
                .request(options)
                .then(function (response) {
                    navigate(`/challenges/${challenge_id}/knowledge/results`);
                    setIsResults(true);
                    setChallengeData('');

                })
                .catch((err) => {
                    let status = err.response.status;
                    console.log("error", status);
                    navigate('/oops');
                });
        } else {
            navigate(`/streams`);
        }
    };

    const getTestCaseValues = (inputString, numOfInputs) => {
        if (inputString === -1) {
            const testData = Array.from({ length: numOfInputs }, () => -1);
            return testData;
        }
        const testData = inputString.split('~~~');
        if (testData.length < numOfInputs) {
            const testData = Array.from({ length: numOfInputs }, () => '<Blank>');
            return testData;
        }
        if (parseInt(numOfInputs) === 1 && testData[0] === '') {
            return ['<Blank>']
        }
        return testData;
    };

    const getNonMinusOneValuesLen = (list) => {
        return list.filter((value) => value !== -1).length
    }

    const dataDisplay = () => {
        if (isResults) {
            return `${challengeData[0].score}/${getNonMinusOneValuesLen(challengeData[0].response.response)}`
        } else {
            return `${getNonMinusOneValuesLen(selectedAnswers)}/${getNonMinusOneValuesLen(challengeData[0].response.response)}`
        }
    }

    const tabBackgroundColour = (currentTabIndex) => {
        if (tcReponses[currentTabIndex].includes(-1)) {
            return 'grey';
        }
        if (isResults) {
            if (challengeData[0].flags[currentTabIndex]) {
                return 'rgb(24, 175, 137)';
            } else {
                return 'rgb(220, 98, 98)';
            }
        }
        if (selectedAnswers[currentTabIndex] === -1) {
            return '#1450a0';
        } else {
            return '#ffc107';
        }
    }

    const resultColour = () => {
        const scorePercent = Math.ceil(100 * challengeData[0].score / getNonMinusOneValuesLen(challengeData[0].response.response));
        if (scorePercent > 70) {
            return '#00ff312b'
        } else {
            return '#ff00002e'
        }

    }
    useEffect(() => {
        if (data?.length) {
            setChallengeData(data);

            createAnsArray(data);
            setMedal(data[1]);
            document.title = props.t('Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheck.title', { challengeName: data[0].name });
            const testCaseResponses = data[0].response.response.map((response) => {
                return getTestCaseValues(response, data[0].num_inputs);
            });
            setTCResponses(testCaseResponses);
            const uuids = Array.from({ length: data[0].numOfTestCases }, () => uuidv4());
            setListUUIDS(uuids);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    const badge = medal === "Gold" ? GoldIcon : medal === "Silver" ? SilverIcon : medal === "Bronze" ? BronzeIcon : "No Badge";

    useEffect(() => {
        if (selectedAnswers !== undefined
            && !selectedAnswers.every(value => value === -1)
            && getNonMinusOneValuesLen(selectedAnswers) !== selectedAnswers.length) {
            setProgressShake(true);
            setTimeout(() => {
                setProgressShake(false);
            }, 500); // adjust the time as needed
        }
    }, [selectedAnswers]);

    const handleDrawer = () => {
        setDrawerOpen(!drawerOpen);
    };


    return (
        <div className={Styles.ancestorContainer} id="ancestorContainer">
            {loading ? (
                <div>
                    <LoadingBackdrop isOpen={true} />
                </div>
            ) : challengeData.length > 0 ?
                <>
                    <ChallengeExplanation
                        showInfo={showExplanation}
                        hideChallengeInfo={hideChallengeInfo}
                        explanation={challengeData[0].explanation}
                        gif_link={challengeData[0].gif_link}
                    />
                    <InfoDrawer
                        drawerOpen={drawerOpen}
                        handleDrawer={handleDrawer}
                        titleText={props.t('Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheck.info')}
                        displayData={tcdata.data}
                    />
                    <div className={Styles.titleContainer} id="titleContainer">
                        <div style={{ width: '100%' }} >
                            <div
                                id='titleInfoContainer'
                                className={Styles.titleInfoContainer}
                            >
                                <LightTooltip
                                    title={props.t('Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheck.tooltip.info')}
                                    arrow
                                    placement="right"
                                >
                                    <div
                                        id='title'
                                        onClick={() => showChallengeInfo()}
                                    >
                                        <p id="challengeName"
                                            className={Styles.homeHeader}
                                        >
                                            <InfoOutlinedIcon fontSize='small'
                                                sx={{
                                                    opacity: 0.5,
                                                    mr: "1px",
                                                }}
                                            />
                                            {challengeData[0].name}
                                        </p>
                                    </div>
                                </LightTooltip>
                                <LightTooltip title={props.t('Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheck.tooltip.hint')} arrow placement="left">
                                    <div id='infoButton' onClick={handleDrawer}>
                                        <Fab color="primary" size="medium">
                                            <LightbulbIcon />
                                        </Fab>
                                    </div>
                                </LightTooltip>
                            </div>
                            <p id="challengeDescr" className={Styles.description}>{challengeData[0].descr}</p>
                        </div>
                    </div>
                    <div id="inferenceContainer" className={Styles.inferenceContainer}>
                        <div id='inferenceTitle' className={Styles.inferenceTitle}>
                            {isResults
                                ? props.t('Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheck.inference.title.results.true') :
                                props.t('Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheck.inference.title.results.false')
                            }
                            {`${challengeData[0].name}`}
                        </div>
                        <div id='tabContainer' className={Styles.tabContainer}>
                            <React.Fragment key={`li-tabsList`}>
                                <Tooltip title={props.t('Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheck.tooltip.navigate')} arrow placement="bottom-end">
                                    <Tabs
                                        value={tabIndex}
                                        onChange={handleTabChange}
                                        TabIndicatorProps={{
                                            sx: {
                                                backgroundColor: '#33691e',
                                                height: 3,
                                            }
                                        }}
                                        variant="scrollable"
                                    >
                                        {challengeData[0].testCases.map((tabLabel, index) => (
                                            <Tab
                                                id={`questionTabs-${index}`}
                                                sx={{
                                                    width: "30px",
                                                    '&.Mui-selected': {
                                                        color: 'black',
                                                    },
                                                }}
                                                key={listUUIDS[index]}
                                                label={
                                                    <div
                                                        id={`tabCircle-${index}`}
                                                        key={`tabCircle-${index}`}
                                                        className={Styles.tabCircle}
                                                        style={{
                                                            backgroundColor: tabBackgroundColour(index),
                                                            //rgb(220, 98, 98). rgb(24, 175, 137)
                                                            color: tcReponses[index].includes(-1) ? 'black' : 'white',
                                                            transition: 'background-color 0.3s ease, color 0.3s ease'
                                                        }}
                                                    >
                                                        {tabLabel + 1}
                                                    </div>
                                                }
                                            />
                                        ))}
                                    </Tabs>
                                </Tooltip>
                            </React.Fragment>
                        </div>
                        <div id='infoContainer' className={Styles.infoContainer}>
                            <Paper elevation={3} sx={{
                                width: '100%',
                                margin: '3px',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                            }}>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar sx={{ background: "linear-gradient(to right, #ce93d8, #9c27b0)" }}>
                                            <ScienceTwoToneIcon />
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText secondary={props.t('Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheck.inference.listItem.secondary')}
                                        primary={
                                            `${_.upperFirst(_.toLower(challengeData[0].testCaseNames[tabIndex]))}`
                                        }
                                    />
                                </ListItem>
                            </Paper>
                            <Paper
                                elevation={3}
                                sx={{
                                    width: '100%',
                                    margin: '3px',
                                    backgroundColor: isResults ? resultColour() : null
                                }}
                                className={`${progressShake ? Styles.flashAmber : ''}`}
                            >
                                <div className={Styles.secondList}>
                                    <ListItem
                                        sx={{
                                            width: 'fit-content'
                                        }}>
                                        <ListItemAvatar>
                                            <Avatar
                                                sx={{
                                                    background: isResults ?
                                                        "linear-gradient(to right, #c8e6c9, #81c784, #4caf50, #388e3c)"
                                                        : "linear-gradient(to right, #ef9a9a, #e57373, #ef5350, #e53935)"
                                                }}>
                                                {
                                                    isResults ?
                                                        <SportsScoreIcon />
                                                        :
                                                        <ListAltIcon />
                                                }

                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            secondary={isResults ? props.t('Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheck.inference.listItem.results.true') : props.t('Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheck.inference.listItem.results.false')}
                                            primary={dataDisplay()}
                                            primaryTypographyProps={{
                                                fontWeight: "bold",
                                            }}
                                            secondaryTypographyProps={{
                                                color: isResults ? "#383838" : "null"
                                            }}
                                        />
                                    </ListItem>
                                    {isResults && <div className={Styles.medalContainer}>
                                        {badge === "No Badge" ?
                                            <p>{props.t('Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheck.noBadge')}</p> :
                                            <img src={badge} width='45px' alt="medal" />}</div>}
                                </div> </Paper>

                        </div>
                        <ChallengeKnowledgeCheckTabs
                            tabIndex={tabIndex}
                            setTestCaseAns={setSelectedAnswers}
                            testCaseAns={selectedAnswers}
                            challengeData={challengeData}
                            testCaseResponses={tcReponses}
                            isResults={isResults}
                        />
                        <div className={Styles.buttonContainer}>
                            <button
                                color="primary"
                                disabled={tabIndex === 0}
                                onClick={() => { setTabIndex(tabIndex - 1) }}
                                className={Styles.buttonStyles}
                            >
                                {props.t('Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheck.button.prev')} </button>
                            <button
                                type='submit'
                                onClick={handleSubmit}
                                className={Styles.buttonStyles}
                                disabled={getNonMinusOneValuesLen(selectedAnswers)
                                    !== getNonMinusOneValuesLen(challengeData[0].response.response) && !isResults}
                                title={getNonMinusOneValuesLen(selectedAnswers)
                                    !== getNonMinusOneValuesLen(challengeData[0].response.response) && !isResults
                                    ? props.t('Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheck.button.submit.title')
                                    : ''}
                            >
                                {isResults ? props.t('Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheck.button.submit.back') : props.t('Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheck.button.submit.submit')}
                            </button>
                            <button
                                disabled={tabIndex === challengeData[0].numOfTestCases - 1}
                                onClick={() => { setTabIndex(tabIndex + 1) }}
                                className={Styles.buttonStyles}
                            >
                                {props.t('Streams.ChallengeKnowledgeCheck.ChallengeKnowledgeCheck.button.next')} </button>
                        </div>
                    </div>
                </>
                : (
                    <div>
                        <LoadingBackdrop isOpen={true} />
                    </div>
                )
            }
        </div >
    );
}